export default __webpack_public_path__ + "static/media/plus-white.09bac619.svg";